import { render, staticRenderFns } from "./b_OneTicket.vue?vue&type=template&id=13a80548&scoped=true&"
import script from "./b_OneTicket.vue?vue&type=script&lang=js&"
export * from "./b_OneTicket.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/page-data-section.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./b_OneTicket.vue?vue&type=style&index=1&id=13a80548&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a80548",
  null
  
)

export default component.exports